import { useRef, useEffect } from 'react';
import {
  HubConnectionBuilder,
  LogLevel,
  JsonHubProtocol,
  HttpTransportType,
} from '@microsoft/signalr';

export default function useSignalR(url, channel, onReceiveMessages) {
  const prevChannel = useRef(null);
  const hubConnection = useRef(null);
  const protocol = new JsonHubProtocol();
  const transport = HttpTransportType.WebSockets;
  const options = {
    transport,
    logMessageContent: true,
    logger: LogLevel.Trace,
  };

  const disposeCallback = () => {
    if (hubConnection.current) {
      try {
        hubConnection.current
          .stop()
          /* .invoke('UnsubscribeFromChannel', prevChannel.current.toLowerCase()) */
          .catch((err) => console.error(err));
      } catch (err) {
        console.error(err);
      }
      try {
        prevChannel.current = null;
      } catch (err) {
        console.error(err);
      }
    }
  };

  const subscribeToChannel = () => {
    if (hubConnection.current && channel) {
      hubConnection.current
        .invoke('SubscribeToChannel', channel.toLowerCase())
        .catch((err) => console.error(err));
    }
  };

  async function start() {
    try {
      console.info('SignalR Try to connect', hubConnection.current.state);
      if (
        hubConnection.current.state !== 'Connected' &&
        hubConnection.current.state !== 'Connecting'
      ) {
        await hubConnection.current.start();
        console.info('SignalR Connected');
        onReceiveMessages.forEach((m) =>
          hubConnection.current.on(m.eventName, m.callback)
        );
        subscribeToChannel();
      }
    } catch (err) {
      console.error(err);
      setTimeout(() => start(), 5000);
    }
  }

  const setupHubConnection = () => {
    //prevChannel.current = channel;
    hubConnection.current = new HubConnectionBuilder()
      .withUrl(url, options)
      .configureLogging(LogLevel.Information)
      .withHubProtocol(protocol)
      //.withAutomaticReconnect()
      .build();
    if (hubConnection.current) {
      start();
      hubConnection.current.onclose(async () => {
        if (prevChannel.current || channel) {
          await start();
        }
      });
    }
  };

  useEffect(() => {
    if (!hubConnection.current) {
      setupHubConnection();
    } else if (channel && channel !== prevChannel.current) {
      prevChannel.current = channel;
      disposeCallback();
      setupHubConnection();
    }
  }, [channel]);

  useEffect(() => {
    return disposeCallback;
  }, []);
}
